import { motion } from 'framer-motion';

const PartnersSection = () => {
  const partners = [
    'AG7',
    'Piemonte',
    'Paysage Corpal',
    'Caçamba do Bem',
    'Arqcom',
  ];

  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="w-full px-12 lg:px-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="inline-block text-xs font-semibold tracking-[0.2em] text-secondary/60 uppercase mb-4">
            Parceiros
          </span>
          <h2 className="text-3xl lg:text-4xl font-semibold text-primary mb-4">
            Empresas que Confiam
          </h2>
          <p className="text-secondary text-lg max-w-2xl mx-auto">
            Parceiros estratégicos que escolhem o Grupo Prime para suas operações
          </p>
        </motion.div>

        <div className="flex flex-wrap items-center justify-center gap-x-12 lg:gap-x-20 gap-y-8">
          {partners.map((name, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="flex items-center justify-center"
            >
              <span className="text-lg lg:text-xl font-medium text-primary/30 hover:text-primary transition-colors duration-500 cursor-default tracking-tight">
                {name}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
